<template>
  <div>
    <Header />
    <main class="inline-flex w-full flex-col items-center bg-slate-100">
      <section
        class="flex h-[calc(100vh-160px)] w-[768px] flex-col items-center bg-slate-50 px-7 pb-12 pt-28 lg:pb-20 lg:pt-20"
      >
        <div class="flex w-[350px] flex-col items-center pt-[30px]">
          <picture>
            <source
              srcset="
                assets/image/img_error/img_error.webp      1x,
                assets/image/img_error/img_error@1.5x.webp 1.5x,
                assets/image/img_error/img_error@2x.webp   2x,
                assets/image/img_error/img_error@3x.webp   3x
              "
              type="image/webp"
            />
            <img src="assets/image/img_error/img_error.png" class="h-40 w-[220px]" alt="error image" loading="lazy" />
          </picture>

          <div v-if="error.statusCode === 404" class="flex flex-col items-center justify-center gap-2.5 pt-5">
            <span class="text-center text-[22px] font-bold leading-[30.80px] text-slate-700">
              {{ $t('error.page.title') }}
            </span>
            <span class="text-center text-[15px] font-normal leading-normal text-slate-700">
              {{ $t('error.page.coment') }}
            </span>
          </div>

          <div v-else>
            <h1>{{ $t('error.server.title') }}</h1>
            <span>{{ $t('error.server.coment') }}</span>
          </div>

          <div class="inline-flex w-full items-start justify-start gap-2.5 pt-10">
            <button
              v-show="error.statusCode != 404"
              class="flex h-12 flex-1 items-center justify-center gap-[5px] rounded-[10px] border border-blue-600 bg-white px-4"
              @click="goBack"
            >
              <span class="text-center text-[15px] font-bold leading-[15px] text-blue-600">
                {{ $t('error.button.back') }}
              </span>
            </button>
            <button
              class="flex h-12 flex-1 items-center justify-center gap-[5px] rounded-[10px] border border-blue-600 bg-white px-4"
              @click="navigateTo(localeRoute('/'), {replace: true})"
            >
              <span class="text-center text-[15px] font-bold leading-[15px] text-blue-600">
                {{ $t('error.button.main') }}
              </span>
            </button>
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
defineProps({
  error: {
    type: Object,
    default: () => {}
  }
})

const localeRoute = useLocaleRoute()
const goBack = () => history.back()
</script>

<style scoped></style>
